<template>
  <el-dialog :visible.sync="isVisible" :title="title" center :close-on-click-modal="false" :show-close="false">
    <div style="line-height: 24px; max-height: 500px; overflow-y: auto;" >
      <p><strong><strong>一、用户须知</strong></strong></p>
      <p>&nbsp;</p>
      <p><strong><strong>产品定位与适用人群：</strong></strong>《门道智能填报系统》是一款专为高考志愿填报提供信息参考的软件产品。未满18周岁的用户需在监护人指导下使用。</p>
      <p><strong><strong>所有权与使用权：</strong></strong>本系统及其相关软件的所有权与运作权归西安门道教育科技有限公司所有。用户通过注册并同意本协议，即表示自愿接受本协议全部内容。如不同意，请勿使用本系统。</p>
      <p><strong><strong>协议变更：</strong></strong>本协议可能因国家政策、产品更新及业务环境变化而进行修改。用户应定期查看并理解修改内容。继续使用系统即视为对修改后的协议表示认可。</p>
      <p>&nbsp;</p>
      <p><strong><strong>二、用户信息条款</strong></strong></p>
      <p>&nbsp;</p>
      <p><strong><strong>注册与账户使用：</strong></strong>用户通过任一渠道注册并接受本协议均具同等效力。账户及其中数据、信息的所有权及知识产权归西安门道教育科技有限公司所有，用户不得转让或非法使用。</p>
      <p><strong><strong>信息真实性：</strong></strong>用户应确保注册信息真实有效，对因信息不真实引起的后果自行承担责任。</p>
      <p><strong><strong>知识产权</strong></strong>：本系统内的文字、图片、视频等内容受版权等法律保护，用户不得擅自复制、修改或创造衍生产品。</p>
      <p><strong><strong>数据准确性：</strong></strong>用户承诺提供的信息和数据真实、详尽、准确，以保证系统计算和分析的准确性。</p>
      <p><strong><strong>系统变更：</strong></strong>系统开发或管理者有权修改、暂停或终止部分功能，并可能设置收费权限。用户需留意公告并承担相应变化带来的影响。</p>
      <p><strong><strong>账户管理：</strong></strong>对于违反协议或法律的行为，系统保留限制、暂停或终止账户的权利。</p>
      <p>&nbsp;</p>
      <p><strong><strong>三、用户使用规则</strong></strong></p>
      <p>&nbsp;</p>
      <p><strong><strong>合法合规：</strong></strong>用户必须遵守国家法律法规，不得利用本系统发送或传播违法信息，包括但不限于危害国家安全、破坏社会稳定、侵犯他人权益等内容。</p>
      <p><strong><strong>使用原则：</strong></strong>用户应遵守网络协议，不得利用系统进行非法活动或干扰互联网正常运转。</p>
      <p><strong><strong>账号安全：</strong></strong>用户需妥善保管账号密码，对账号下的一切活动负责。因账号泄露或不当使用造成的损失，由用户自行承担。</p>
      <p><strong><strong>禁止行为：</strong></strong>禁止未经授权收集、复制、传播系统内容，禁止通过逆向工程等手段获取系统源码，禁止利用软件、脚本等工具非法抓取数据。</p>
      <p>&nbsp;</p>
      <p><strong><strong>四、系统声明</strong></strong></p>
      <p>&nbsp;</p>
      <p><strong><strong>数据来源与准确性：</strong></strong>本系统所展示、公布、使用的数据均来源于官方或高校，仅供参考，因依赖系统数据产生的风险自行承担。由于统计规则和数据处理方式可能存在差异，部分数据与其他平台公布数据不一致属于正常现象。</p>
      <p><strong><strong>志愿填报建议：</strong></strong>系统不保证推荐的志愿填报方案必然导致录取，对结果的准确性不承担任何形式的担保责任。</p>
      <p><strong><strong>会员服务期限：</strong></strong>有偿会员服务期限至高考年份8月31日止，期间部分功能非当年高考用户不可用。</p>
      <p><strong><strong>安全提示</strong></strong>：用户应自行承担因网络安全问题导致的损失，包括但不限于个人信息泄露、密码被盗等。</p>
      <p><strong><strong>运营调整</strong></strong>：系统有权根据运营需要修改或中断服务，无需向第三方承担责任。</p>
      <p><strong><strong>法律责任：</strong></strong>系统保留对用户违规行为进行管理的权利，包括但不限于删除内容、关闭账户等，并依法追究法律责任。</p>
      <p><strong><strong>技术风险</strong></strong>：因互联网技术不稳定导致的问题，系统不承担赔偿责任。</p>
      <p>&nbsp;</p>
      <p><strong><strong>五、其他</strong></strong></p>
      <p>&nbsp;</p>
      <p><strong><strong>用户确认</strong></strong>：用户确认已完全理解并接受本协议所有条款，自愿承担相应义务与责任。</p>
      <p><strong><strong>法律适用与争议解决：</strong></strong>本协议受中华人民共和国法律管辖。争议应友好协商解决，协商不成时，提交西安门道教育科技有限公司所在地法院诉讼解决。</p>
      <p><strong><strong>协议生效：</strong></strong>点击&ldquo;同意&rdquo;按钮即表示用户已完全理解并接受本协议内容。</p>
      <p>&nbsp;</p>
      <p>&nbsp;</p>
    </div>
    <div slot="footer">
      <el-button @click="onConfirm" type="primary">同意</el-button>
      <el-button @click="isVisible = false">关闭</el-button>
    </div>
  </el-dialog>
</template>
<script>

export default {
  inheritAttrs: false,
  components: {},
  props: {
    // dialogVisible: {
    //   type: Boolean,
    //   default: false
    // },
    title: {
      type: String,
      default: '《门道大数据智能填报系统》用户协议'
    },
  },
  data() {
    return {
      dialogVisible: false,
    }
  },
  computed: {
    // 弹窗是否可见
    isVisible: {
      get() {
        return this.dialogVisible
      },
      set(value) {
        this.dialogVisible = value
        this.close()
        this.reset()
      }
    },
  },
  watch: {},
  created() {},
  mounted() {},
  methods: {
    close() {
      this.$emit('update:dialogVisible', false)
    },
    reset() {},

    open() {
      this.isVisible = true
    },

    onConfirm() {
      this.isVisible = false
      this.$emit('confirm')
    }
  }
}

</script>
<style lang="scss" scoped>

</style>
